import store from '@/store/index.js'
import ValidaCpfCnpj from '@/libs/cpfcnpj'
import { makeRequest } from '@/libs/RequestModule'
import { setLocalVar, findCep } from '@/libs/Util.js'
import { sanitizeString, sanitizeNumber, sanitizeMoney } from '@/components/controllers/FormatController.js'
import { log } from '@/libs/Logger.js'

const getConsumerDetails = () => {
    makeRequest('getConsumerDetails', {})
        .then(response => {
            if (response?.sucesso && response.data) {
                store.dispatch('setProfileFields', response.data)
            } else {
                log({ type: 'error', message: `Resposta inesperada em getConsumerDetails: ${JSON.stringify(response)}` })
            }
        })
        .catch(error => {
            log({ type: 'error', message: `Erro em getConsumerDetails:\n${error.message}` })
        })
        .finally(() => {
            store.dispatch('stopLoading')
        })
}

const getConsumerDetailsRaw = async () => {
    return (await makeRequest('getConsumerDetails', {}))?.data
}

const updateProfile = () => {
    const payload = buildUpdateProfilePayload()
    makeRequest('updateProfile', payload)
        .then(response => {
            if (response?.sucesso && response.data?.consDetails) {
                setLocalVar('SESSIONTOKEN', response?.data?.ACCESSTOKEN)
                store.dispatch('setProfileFields', response.data.consDetails)
            } else {
                log({ type: 'error', message: `Resposta inesperada em updateProfile: ${JSON.stringify(response)}` })
            }
        })
        .catch(error => {
            log({ type: 'error', message: `Erro em updateProfile:\n${error.message}` })
        })
        .finally(() => {
            store.dispatch('stopLoading')
        })
}

const buildUpdateProfilePayload = () => {
    const personalData = store.getters.profileFields.personalData
    const addressData = store.getters.profileFields.addressData
    const integrationData = store.getters.profileFields.integrationData
    const checkboxes = store.getters.profileFields.checkboxes
    const childrenPhones = []

    const payload = {
        NMRESPCONS: personalData[0].value ? sanitizeString(personalData[0].value) : null,
        NRCPFRESPCON: personalData[1].value ? sanitizeNumber(personalData[1].value) : null,
        DSEMAILCONS: personalData[2].value ? sanitizeString(personalData[2].value) : null,
        NRCELULARCONS: personalData[3].value ? sanitizeNumber(personalData[3].value) : null,
        sonNotifVal: personalData[4].value ? sanitizeMoney(personalData[4].value) : null,
        DSENDECONS: addressData[0].value ? sanitizeString(addressData[0].value) : null,
        NRCEPCONS: addressData[1].value ? sanitizeNumber(addressData[1].value) : null,
        NRENDECONS: addressData[2].value ? sanitizeString(addressData[2].value) : null,
        DSCOMPLENDECONS: addressData[3].value ? sanitizeString(addressData[3].value) : null,
        DSREFERENDECONS: addressData[4].value ? sanitizeString(addressData[4].value) : null,
        NMBAIRCONS: addressData[7].value ? sanitizeString(addressData[7].value) : null,
        CDPAIS: '0055',
        SGESTADO: addressData[5].value || null,
        CDMUNICIPIO: addressData[6].code,
        HABENVEMAIL: checkboxes[0].value ? 'S' : 'N',
        HABENVNOTIF: checkboxes[1].value ? 'S' : 'N'
    }

    if (integrationData.fields?.length > 0) {
        integrationData.fields.forEach(child => {
            childrenPhones.push({
                NMCONSUMIDOR: child.display,
                CDCONSUMIDOR: child.consumer,
                PHONE: sanitizeNumber(child.value)
            })
        })
    }

    payload.childrenPhones = childrenPhones
    return payload
}

const changePassword = async (currentPassword, newPassword) => {
    return (await makeRequest('changePassword', { currentPassword, newPassword }))?.data
}

const validateProfileFields = async () => {
    let resultObject = {
        isValid: true,
        messages: []
    }

    const personalData = store.getters.profileFields.personalData
    const addressData = store.getters.profileFields.addressData
    const integrationFields = store.getters.profileFields.integrationData.fields

    resultObject = validateArrayFields(personalData, resultObject)
    resultObject = validateArrayFields(addressData, resultObject)
    resultObject = validateArrayFields(integrationFields, resultObject)
    resultObject = await validateCEP(addressData, resultObject)

    if (resultObject.messages.length > 0) resultObject.messages.reverse()

    return resultObject
}

const validateArrayFields = (array, resultObject) => {
    if (array?.length > 0) {
        for (let i = 0; i < array.length; i++) {
            const element = array[i]
            if (element.required && !correctlyFilled(element)) {
                resultObject.isValid = false
                resultObject.messages.push(`O campo ${element.display} deve ser preenchido corretamente.`)
            }
        }
    }
    return resultObject
}

const correctlyFilled = (field, value) => {
    let input = field.value || value || ''

    if (field.format === 'cpf') {
        return ValidaCpfCnpj.validaCpfCnpj(input)
    } else if (field.format === 'email') {
        const mailRegex = /\S+@\S+\.\S+/
        return mailRegex.test(input)
    } else if (field.format === 'cellNumber') {
        input = sanitizeNumber(input)
        return input?.length === 11
    } else if (field.format === 'phoneNumber') {
        input = sanitizeNumber(input)
        return input?.length === 10
    } else if (field.format === 'cep') {
        input = sanitizeNumber(input)
        return input?.length === 8
    } else {
        return input.trim().length > 0
    }
}

const validateCEP = async (addressData, resultObject) => {
    const cep = addressData[1].value

    if (cep && cep !== '') {
        const cepData = await findCep(cep)

        if (!cepData || cepData.erro) {
            resultObject.isValid = false
            resultObject.messages.push('O CEP inserido não é válido')
        }
    }

    return resultObject
}

export { getConsumerDetails, updateProfile, changePassword, validateProfileFields, correctlyFilled, getConsumerDetailsRaw }
